interface FormatMoneyOptions {
  value: number
  locale: string
  currency: server.dto.Currencies | undefined
  displayCents: boolean
}

export const formatMoney = ({ value, locale, currency, displayCents }: FormatMoneyOptions) => {
  const fractionDigits = displayCents ? 2 : 0;
  const formatted = new Intl.NumberFormat(locale, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  }).format(value);

  if (currency === undefined) return formatted;

  return `${formatted} ${currency.toUpperCase()}`;
};

interface FormatMoneyDtoOptions {
  money: server.dto.Money
  locale: string
  displayCents: boolean
}

export const formatMoneyDto = ({ money, locale, displayCents }: FormatMoneyDtoOptions) =>
  formatMoney({ value: money.amount, locale, currency: money.currency, displayCents });

export const getExchangeRateFormatter = (locale: string) => new Intl.NumberFormat(locale, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 5
});

export const getPercentageFormatter = (locale: string, decimalDigits: number) => new Intl.NumberFormat(locale, {
  style: "percent",
  maximumFractionDigits: decimalDigits
});

export const getNumberFormatter = (locale: string, options?: Intl.NumberFormatOptions) => new Intl.NumberFormat(locale, options);

export const formatUrl = (url: string) => {
  const withScheme = url.includes("://") ? url : `https://${url}`;

  try {
    const parsedUrl = new URL(withScheme);

    return parsedUrl.hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
}
